// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_om-0";